module.exports = __webpack_public_path__ + "static/media/carrorama-elite.373f0b3b.png";